import { render, staticRenderFns } from "./busWitness_list_detail.vue?vue&type=template&id=593b5ebc&scoped=true"
import script from "./busWitness_list_detail.vue?vue&type=script&lang=js"
export * from "./busWitness_list_detail.vue?vue&type=script&lang=js"
import style0 from "./busWitness_list_detail.vue?vue&type=style&index=0&id=593b5ebc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593b5ebc",
  null
  
)

export default component.exports